import { undoDepth, redoDepth, history, undo, redo } from 'prosemirror-history';
import { CommonExtension } from '../../../core/index.js';
import 'prosemirror-model';

var isUndoDisabled = function() {
    return function(state, dispatch, view) {
        return undoDepth(state) < 1;
    };
};

var isRedoDisabled = function() {
    return function(state, dispatch, view) {
        return redoDepth(state) < 1;
    };
};

var convertCommand = function(commandFunction) {
    return function(param) {
        var state = param.state, dispatch = param.dispatch, view = param.view, args = param.args;
        return commandFunction(state, dispatch, view, args);
    };
};

function _assertThisInitialized(self) {
    if (self === void 0) {
        throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
    }
    return self;
}
function _classCallCheck(instance, Constructor) {
    if (!(instance instanceof Constructor)) {
        throw new TypeError("Cannot call a class as a function");
    }
}
function _defineProperties(target, props) {
    for(var i = 0; i < props.length; i++){
        var descriptor = props[i];
        descriptor.enumerable = descriptor.enumerable || false;
        descriptor.configurable = true;
        if ("value" in descriptor) descriptor.writable = true;
        Object.defineProperty(target, descriptor.key, descriptor);
    }
}
function _createClass(Constructor, protoProps, staticProps) {
    if (protoProps) _defineProperties(Constructor.prototype, protoProps);
    if (staticProps) _defineProperties(Constructor, staticProps);
    return Constructor;
}
function _getPrototypeOf(o) {
    _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) {
        return o.__proto__ || Object.getPrototypeOf(o);
    };
    return _getPrototypeOf(o);
}
function _inherits(subClass, superClass) {
    if (typeof superClass !== "function" && superClass !== null) {
        throw new TypeError("Super expression must either be null or a function");
    }
    subClass.prototype = Object.create(superClass && superClass.prototype, {
        constructor: {
            value: subClass,
            writable: true,
            configurable: true
        }
    });
    if (superClass) _setPrototypeOf(subClass, superClass);
}
function _possibleConstructorReturn(self, call) {
    if (call && (_typeof(call) === "object" || typeof call === "function")) {
        return call;
    }
    return _assertThisInitialized(self);
}
function _setPrototypeOf(o, p) {
    _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) {
        o.__proto__ = p;
        return o;
    };
    return _setPrototypeOf(o, p);
}
var _typeof = function(obj) {
    "@swc/helpers - typeof";
    return obj && typeof Symbol !== "undefined" && obj.constructor === Symbol ? "symbol" : typeof obj;
};
function _isNativeReflectConstruct() {
    if (typeof Reflect === "undefined" || !Reflect.construct) return false;
    if (Reflect.construct.sham) return false;
    if (typeof Proxy === "function") return true;
    try {
        Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function() {}));
        return true;
    } catch (e) {
        return false;
    }
}
function _createSuper(Derived) {
    var hasNativeReflectConstruct = _isNativeReflectConstruct();
    return function _createSuperInternal() {
        var Super = _getPrototypeOf(Derived), result;
        if (hasNativeReflectConstruct) {
            var NewTarget = _getPrototypeOf(this).constructor;
            result = Reflect.construct(Super, arguments, NewTarget);
        } else {
            result = Super.apply(this, arguments);
        }
        return _possibleConstructorReturn(this, result);
    };
}
var HistoryExtension = /*#__PURE__*/ function(CommonExtension) {
    _inherits(HistoryExtension, CommonExtension);
    var _super = _createSuper(HistoryExtension);
    function HistoryExtension() {
        _classCallCheck(this, HistoryExtension);
        return _super.apply(this, arguments);
    }
    var _proto = HistoryExtension.prototype;
    _proto.plugin = function plugin() {
        return history();
    };
    _proto.commands = function commands() {
        return {
            undo: function() {
                return undo;
            },
            redo: function() {
                return redo;
            },
            isUndoDisabled: isUndoDisabled,
            isRedoDisabled: isRedoDisabled
        };
    };
    _proto.keys = function keys() {
        return {
            "Mod-z": convertCommand(undo),
            "Mod-y": convertCommand(redo),
            "Mod-Shift-z": convertCommand(redo)
        };
    };
    _createClass(HistoryExtension, [
        {
            key: "name",
            get: function get() {
                return "history";
            }
        }
    ]);
    return HistoryExtension;
}(CommonExtension);

export { HistoryExtension };
//# sourceMappingURL=index.js.map
